import { IconButton } from "@mui/material";
import { Eye } from "iconsax-react";

interface IDeleteActionProps {
  handleView: () => void;
  disabled?: boolean;
}

export default function ViewAction({
  handleView,
  disabled,
}: Readonly<IDeleteActionProps>) {
  return (
    <IconButton
      disabled={disabled}
      onClick={handleView}
      sx={{
        padding: "4px",
        borderRadius: "50%",
        width: "fit-content",
        cursor: "pointer",
        bgcolor: "transparent",
        // mx: "auto",
        display: disabled ? "none" : "block",

        "&:hover": {
          color: (theme) => theme.palette.others.active,
          backgroundColor: "transparent",
        },
      }}
    >
      <Eye
        size="18"
        //  color="#FF8A65"
      />
    </IconButton>
  );
}
